import { atom } from 'jotai';

/**
 * Search form input value
 * Persists across navigation so users don't lose their input
 */
export const searchInputAtom = atom<string>('');

/**
 * Write-only atom to clear search input after submission
 */
export const clearSearchInputAtom = atom(null, (_get, set) => set(searchInputAtom, ''));

/**
 * Pending conversation for optimistic navigation.
 * Set by SearchForm before router.push(), consumed by Conversation.tsx on mount.
 * Bridges the gap between /new page submission and conversation page initialization.
 */
export const pendingConversationAtom = atom<{ conversationId: string; prompt: string } | null>(null);
